import { render, staticRenderFns } from "./briefIntroduction.vue?vue&type=template&id=8c92216a&scoped=true&"
import script from "./briefIntroduction.vue?vue&type=script&lang=js&"
export * from "./briefIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./briefIntroduction.vue?vue&type=style&index=0&id=8c92216a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c92216a",
  null
  
)

export default component.exports